import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { Globle } from 'src/assets/globle';
import { menuPerm } from '../master/menuPerm.model';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private globle: Globle,
    private http: HttpClient,
    private localStorage: LocalStorageService,
    private sessionStorage: SessionStorageService) { }

  login(obj: any) {
    return this.http.post<any>(this.globle.APIURL + "identity/loginadmin", obj)
  }

  changePassword(obj: any) {
    return this.http.post<any>(this.globle.APIURL + "identity/changepassword", obj)
  }

  resetPassword(obj: any) {
    return this.http.post<any>(this.globle.APIURL + "identity/adminresetpassword", obj)
  }

  loggedIn() {
    return !!this.sessionStorage.retrieve("token");
  }

  logout() {
    this.localStorage.clear();
    this.sessionStorage.clear();
    window.location.href = "";
  }

  getAuthToken() {
    var token = this.sessionStorage.retrieve("token");
    return token
  }

  getById(id: string) {
    return this.http.post<any>(this.globle.APIURLV2 + "users/getbyid/" + id, null);
  }



}
